import { NewInRoleChangeType } from "@/enum/company-enrich-type.enum";

export type NewInRoleWindowPreset = "30" | "90" | "180" | "365" | "custom";

// Preset values map to a translation key resolved in the component (see NewInRoleTriggerSection).
export const NEW_IN_ROLE_WINDOW_PRESETS: { value: NewInRoleWindowPreset; labelKey: string }[] = [
	{ value: "30", labelKey: "newInRoleWindow30" },
	{ value: "90", labelKey: "newInRoleWindow90" },
	{ value: "180", labelKey: "newInRoleWindow180" },
	{ value: "365", labelKey: "newInRoleWindow365" },
	{ value: "custom", labelKey: "newInRoleWindowCustom" },
];

export const NEW_IN_ROLE_CHANGE_TYPES: {
	value: NewInRoleChangeType;
	labelKey: string;
	/** Optional clarifying note shown via an info tooltip next to the label. */
	infoKey?: string;
}[] = [
	{
		value: NewInRoleChangeType.NEW_ROLE,
		labelKey: "newInRoleStartedNewRole",
		infoKey: "newInRoleStartedNewRoleInfo",
	},
	{
		value: NewInRoleChangeType.NEW_EMPLOYER,
		labelKey: "newInRoleStartedNewEmployer",
	},
];
